(ns frontend.view.reports.events
  (:require [frontend.conn :as conn]
            [frontend.view.reports.db :as db]
            [clojure.string :as string]
            [frontend.state.current-session :as session]
            [common.util :as cu]))

(defn opts-name [v]
  (cond
    (keyword? v) (name v)
    (integer? v) (str v)
    :else v))

(defn state-key [k opts]
  (if (and (pos? (count opts))
           (not (:dont-identify-opts? opts)))
    (keyword (name k) (string/join
                        (->> opts
                             (map (fn [opt]
                                    (opts-name (val opt)))))))
    k))

(defn fetch-data! [[k opts]]
  (when k
    (conn/send! (->> k
                     name
                     (keyword "report"))
                (dissoc opts :dont-identify-opts?)
                (fn [{:keys [body]}]
                  (swap! db/state
                         assoc
                         (state-key k opts)
                         body)
                  true))))

(defn delete-data! [[k opts]]
  (swap! db/state
         dissoc
         (state-key k opts)))

(defn get-data!
  ([k]
   (get-data! k {}))
  ([k opts]
   (let [cached-reports @session/all-cached-reports
         sessions-key (state-key :tenant-sessions opts)
         users-key (state-key :tenant-users opts)]
     (case k
       :new-deals-per-funding-round (->> cached-reports
                                         (cu/filter-by :cached-report/report-key :cached-report.type/new-deals-per-funding-round)
                                         (sort-by :common/updated-on)
                                         (last)
                                         :cached-report/value)
       :new-deals-per-person (->> cached-reports
                                  (cu/filter-by :cached-report/report-key :cached-report.type/new-deals-per-account)
                                  (sort-by :common/updated-on)
                                  (last)
                                  :cached-report/value)
       :new-deals-per-owner (->> cached-reports
                                 (cu/filter-by :cached-report/report-key :cached-report.type/new-deals-per-owner)
                                 (sort-by :common/updated-on)
                                 (last)
                                 :cached-report/value)
       :new-deals-per-lead-source (->> cached-reports
                                       (cu/filter-by :cached-report/report-key :cached-report.type/new-deals-per-lead-source)
                                       (sort-by :common/updated-on)
                                       (last)
                                       :cached-report/value)
       :new-deals-per-lead-type (->> cached-reports
                                     (cu/filter-by :cached-report/report-key :cached-report.type/new-deals-per-lead-type)
                                     (sort-by :common/updated-on)
                                     (last)
                                     :cached-report/value)
       (get @db/state (state-key k opts))))))
